import { Link } from 'react-router-dom';
import { ICustomField, ICustomValue } from '../../entities/automation.entities';
import { Dropdown, Input } from '../shared';
import { translate } from '../../lib/lang.helper';
import { useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';

interface Props {
  values: ICustomValue[];
  fields: ICustomField[];
  onChange: (d: ICustomValue[]) => void;
  disabled?: boolean;
}

const CustomValuesForm = ({ values, fields, onChange, disabled }: Props) => {
  const lang = useSelector(selectLang);

  const updateCustomValue = (id: number, value: string) => {
    let tmp = [...values];
    const i = tmp.findIndex(v => v.field_id === id);
    if (i >= 0) {
      tmp[i].field_val = value;
    } else {
      tmp.push({ field_id: id, field_val: value });
    }
    onChange(tmp);
  };

  return (
    <>
      {fields.map(field => {
        const value = values.find(v => v.field_id === field.id);
        const options = field.options
          ?.split(',')
          .map(t => ({ id: t, label: t, value: t }));

        return (
          <div key={field.id} className='mb-17'>
            {field.input_type === 'select' ? (
              <>
                <Dropdown
                  label={field.name}
                  options={options ?? []}
                  value={value?.field_val ?? ''}
                  onChange={v => updateCustomValue(field.id, v)}
                  disabled={disabled}
                />
                {(!options || options.length <= 0) && (
                  <Link to={'/custom-fields'}>
                    <span style={{ color: '#008ed1' }}>
                      {translate(lang, 'Set up field')}
                    </span>
                  </Link>
                )}
              </>
            ) : (
              <Input
                type={field.data_type === 'number' ? 'number' : 'text'}
                label={field.name}
                value={value?.field_val ?? ''}
                onChange={e => updateCustomValue(field.id, e.target.value)}
                unit={field.unit}
                disabled={disabled}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

export default CustomValuesForm;
